import { RedoDateRangePicker } from "@redotech/redo-web/arbiter-components/date-picker/redo-date-range-picker";
import { memo } from "react";

export const MarketingDateRangeFilter = memo(function MarketingDateRangeFilter({
  dateFilter,
  setDateFilter,
}: {
  dateFilter: [Temporal.PlainDate, Temporal.PlainDate] | undefined;
  setDateFilter(
    dateFilter: [Temporal.PlainDate, Temporal.PlainDate] | undefined,
  ): void;
}) {
  function handleSetCustomDateValue(
    value: [Temporal.PlainDate, Temporal.PlainDate] | undefined,
  ) {
    if (!value) {
      setDateFilter(undefined);
      return;
    }

    setDateFilter(value);
  }

  return (
    <RedoDateRangePicker
      allowNoDateOption
      dateRange={dateFilter ? [dateFilter[0], dateFilter[1]] : undefined}
      labelText="Date"
      setDateRange={handleSetCustomDateValue}
      size="sm"
    />
  );
});
